export const EXERCISE_GAP_FILL = 'exercise-gap-fill';
export const EXERCISE_GAP_FILL_QUESTION = 'exercise-gap-fill-question';
export const EXERCISE_GAP_FILL_QUESTION_CONTENT = 'exercise-gap-fill-question-content';
export const EXERCISE_GAP_FILL_HINTS = 'exercise-gap-fill-hints';

export type ExerciseGapFillOptions = {
  isReadOnly?: boolean;
  onBackWhenInComplete?: () => void;
};

export type ExerciseGapFillQuestionOptions = {
  isReadOnly?: boolean;
};

export type CreteGapFillQuestionOptions = {
  question?: string;
  explanation?: string;
  options?: string[];
  correctOptions?: string[];
};

export const GAP_FILL_PARAGRAPH_TOGGLE_TYPES = {
  GUIDE: 'gap-fill-guide',
  HEADING: 'gap-fill-heading',
  QUESTION_CONTENT: 'gap-fill-question-content',
};
